<template>
  <div
    v-if="isKaguidoOptionAvailable"
    id="yhc-ef-kaguido-option"
    class="yhc-ef-kaguido-option mb-5"
  >
    <YhcEFSectionTitle @click="toggle"
      >ちょこっと模様替え(家具家電移動オプション)</YhcEFSectionTitle
    >
    <div class="yhc-ef-kaguido-option-title pt-3">
      <p class="text-center">
        お預かり先やお届け先の家屋内で<strong>重い家具・家電の移動が必要な場合</strong>にご利用いただくオプションサービスです。
      </p>
      <h4 class="text-center">
        <span class="highlight-text">家財おまかせ便と同時申込みで大変お得！</span><br />
        1点あたり<span class="price-text"
          >1,100円<span style="font-size: 0.8rem">(税込)</span>から</span
        >ご利用いただけます！
      </h4>
      <div class="yhc-ef-kaguido-option--scene-wrapper">
        <p class="text-center use-case-title">こんな時に是非ご利用ください</p>
        <ul class="yhc-ef-kaguido-option--scene-body">
          <li>重い家具を別の部屋に移動したいが、一人では困難</li>
          <li>お届け先で既存の家具・家電を移動する必要がある</li>
          <li>引っ越しと同時に部屋の模様替えをしたい</li>
          <li>大型の家具・家電の配置を変更したい</li>
        </ul>
      </div>
      <div class="text-center">
        <span class="notice-text bold"
          >※ちょこっと模様替えをご利用の際はWeb申込みフォームの"オプショナルサービスの利用について"を"有"にてお申込みください。</span
        >
      </div>
    </div>
    <!-- <div class="text-center">
      詳細は<a href="https://www.008008.jp/transport/furniture/01/" target="_blank" rel="noopener"
        >こちら</a
      >をご確認ください。
    </div> -->
    <div class="yhc-ef-kaguido-option-wrapper">
      <div
        v-if="!isKaguidoOptionAvailableForFromArea || !isKaguidoOptionAvailableForToArea"
        class="yhc-ef-kaguido-option--alert text-center"
      >
        ※{{
          !isKaguidoOptionAvailableForFromArea ? 'お預かり先' : 'お届け先'
        }}がオプション利用不可エリアのため、{{
          !isKaguidoOptionAvailableForFromArea ? 'お預かり先' : 'お届け先'
        }}のちょこっと模様替えは利用できません。
      </div>
      <div
        v-if="isKaguidoOptionAvailableForFromArea"
        class="yhc-ef-kaguido-option--description text-center"
      >
        <span class="yhc-ef-kaguido-option--destination">お預かり先で利用する場合</span
        >、下記枠内をクリックして家財選択画面にお進みください。
      </div>
      <div
        v-if="isKaguidoOptionAvailableForFromArea"
        class="yhc-ef-item-list pt-2"
      >
        <!-- すでに追加されたものを表示 -->
        <YhcEFKaguidoOptionAddedItem
          v-for="(kazaiData, kazaiDataId) in $yhcefs.$userInputData
            .userAddedKazaiDataByIdForKaguidoOptionCollectionDestination"
          :key="kazaiDataId"
          :kazaiData="kazaiData"
          :isKaguidoFrom="true"
        />
        <!-- 新規追加 button -->
        <YhcEFItemListAddNewKazaiArea
          :isKaguidoOption="true"
          :isKaguidoFrom="true"
        />
      </div>
      <div
        v-if="isKaguidoOptionAvailableForToArea"
        class="yhc-ef-kaguido-option--description text-center pt-2"
      >
        <span class="yhc-ef-kaguido-option--destination">お届け先で利用する場合</span
        >、下記枠内をクリックして家財選択画面にお進みください。
      </div>
      <div
        v-if="isKaguidoOptionAvailableForToArea"
        class="yhc-ef-item-list pt-2"
      >
        <!-- すでに追加されたものを表示 -->
        <YhcEFKaguidoOptionAddedItem
          v-for="(kazaiData, kazaiDataId) in $yhcefs.$userInputData
            .userAddedKazaiDataByIdForKaguidoOptionDeliveryDestination"
          :key="kazaiDataId"
          :kazaiData="kazaiData"
          :isKaguidoFrom="false"
        />
        <!-- 新規追加 button -->
        <YhcEFItemListAddNewKazaiArea
          :isKaguidoOption="true"
          :isKaguidoFrom="false"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import YhcEFItemListAddNewKazaiArea from '../YhcEFItemList/YhcEFItemListAddNewKazaiArea.vue'
import { YhcEstimateFormFrontService } from '../../YhcEstimateFormFrontService'
import YhcEFKaguidoOptionAddedItem from './YhcEFKaguidoOptionAddedItem.vue'

export default {
  components: { YhcEFItemListAddNewKazaiArea, YhcEFKaguidoOptionAddedItem },
  inject: ['YhcEstimateFormFrontServiceInstance'],
  computed: {
    $yhcefs(): YhcEstimateFormFrontService {
      return this.YhcEstimateFormFrontServiceInstance
    },
    isKaguidoOptionAvailable(): boolean {
      return (
        !this.$yhcefs.$userInputData.isContainUnavailableArea &&
        this.$yhcefs.$userInputData.isKaguidoOptionAvailable
      )
    },
    isKaguidoOptionAvailableForFromArea(): boolean {
      return this.$yhcefs.$userInputData.isKaguidoOptionAvailableForFromArea
    },
    isKaguidoOptionAvailableForToArea(): boolean {
      return this.$yhcefs.$userInputData.isKaguidoOptionAvailableForToArea
    },
  },
  data() {
    return {
      isOpen: false,
    }
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen
    },
  },
}
</script>
<style lang="scss">
.yhc-ef-kaguido-option {
  a {
    color: var(--yhc-color);
  }

  .yhc-ef-kaguido-option-title {
    padding: var(--yhc-base-pad);

    .highlight-text {
      background-color: var(--yhc-color-yellow);
      font-weight: bold;
      padding: 2px 8px;
      border-radius: 15px;
      display: inline-block;
    }

    .price-text {
      color: var(--yhc-color-blue);
      font-size: 1.2em;
      font-weight: bold;
    }

    .yhc-ef-kaguido-option--scene-wrapper {
      border: 2px solid var(--yhc-color);
      border-radius: 10px;
      padding: var(--yhc-base-pad);
      margin: 15px 0;
      background-color: #f0f8ff; // 薄い青色の背景
      box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.3);

      .use-case-title {
        font-weight: bold;
        font-size: 16px;
        color: var(--yhc-color);
      }

      .yhc-ef-kaguido-option--scene-body {
        list-style-type: none;
        padding-left: 0;
        margin-bottom: 0;
        font-size: 14px;

        li {
          position: relative;
          padding-left: 1.5em;
          margin-bottom: 1px;

          &:last-child {
            margin-bottom: 0;
          }

          &::before {
            content: '•';
            position: absolute;
            left: 0;
            color: var(--yhc-color);
            font-weight: bold;
          }
        }
      }
    }
  }

  .yhc-ef-kaguido-option-wrapper {
    padding: var(--yhc-base-pad);

    .yhc-ef-kaguido-option--alert {
      font-size: 18px;
      font-weight: bold;
      color: #ff4500;

      @media screen and (max-width: 757px) {
        font-size: 16px;
      }
    }

    .yhc-ef-kaguido-option--destination {
      font-size: 18px;
      font-weight: bold;
      color: var(--yhc-color-blue);

      @media screen and (max-width: 757px) {
        font-size: 16px;
      }
    }

    .yhc-ef-kaguido-option--description {
      font-size: 16px;
      color: #666;

      @media screen and (max-width: 757px) {
        font-size: 14px;
      }
    }
  }

  .notice-text {
    font-size: 0.9rem;
    padding: 0 10px;
  }
}
</style>
